/** Format the always-visible chrome build string: short git SHA only.
 *  No native versionName/versionCode — those never get bumped without an
 *  actual release process, so they'd just be permanent dead weight ("1.0
 *  (1)", forever) next to the one thing that actually changes per deploy.
 *  Reintroduce native version display once there's a real release cadence
 *  for it to mean something.
 */

export const VERSION_UNAVAILABLE = 'version unavailable';

export function shortenSha(sha) {
  const s = String(sha || '').trim();
  if (!s) return '';
  if (/^[0-9a-f]{7,40}$/i.test(s)) return s.slice(0, 8).toLowerCase();
  return s;
}

export function formatBuildStamp({ sha } = {}) {
  const shaShort = shortenSha(sha);
  return shaShort || VERSION_UNAVAILABLE;
}
